import { Star, MapPin, Award } from 'lucide-react';

export const TrustBar = () => {
  const items = [
    { icon: Star, label: '3,300+ Fresha Reviews' },
    { icon: MapPin, label: 'Downtown Vancouver — Steps from Burrard SkyTrain' },
    { icon: Award, label: 'YUMI Certified + InLei Certified Lash Artists' },
  ];
  return (
    <div
      data-testid="trust-bar"
      className="bg-brand-bgElev border-y border-brand-gold/15"
    >
      <div className="container-prep py-5 sm:py-6 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-12">
        {items.map(({ icon: Icon, label }) => (
          <div
            key={label}
            className="flex items-center gap-2.5 text-[11px] sm:text-[12px] uppercase tracking-[0.22em] font-medium text-brand-cream/80"
          >
            <Icon size={14} className="text-brand-gold" />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBar;
